import { render, staticRenderFns } from "./baomingtiaojian.vue?vue&type=template&id=4a71481c&scoped=true"
import script from "./baomingtiaojian.vue?vue&type=script&lang=js"
export * from "./baomingtiaojian.vue?vue&type=script&lang=js"
import style0 from "./baomingtiaojian.vue?vue&type=style&index=0&id=4a71481c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71481c",
  null
  
)

export default component.exports